export const setLocalStorageData = (title, value) => {
  localStorage.setItem(title, value);
};

export const getLocalStorageData = (title) => {
  return localStorage.getItem(title);
};

export const removeLocalStorageData = (title) => {
  localStorage.removeItem(title);
};
